import React, { useState } from "react";
import "./NowVsFutureComparison.css";

const NowVsFutureComparison = () => {
  const [mode, setMode] = useState("now"); // "now" | "future"

  const income = 50000;

  // Simple illustrative numbers – you can replace with real math later
  const now = {
    pathA: 0, // total taxes this year
    pathB: 2000,
  };

  const future = {
    pathA:  0, // total taxes over 20 years
    pathB: 50000,
  };

  const format = (n) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    }).format(n);

  const isNow = mode === "now";
  const activeData = isNow ? now : future;

  return (
    <div className="nvf-root">
      <h2 className="nvf-title">Same Eligiblity. Different Scenarios.</h2>
      <p className="nvf-subtitle">
Unlike one-time events, many tax-related items occur repeatedly, with some happening every year.
      </p>

      {/* Toggle: Today vs 20 years */}
      <div className="nvf-toggle">
        <button
          type="button"
          className={`nvf-toggle-btn ${isNow ? "nvf-toggle-btn--active" : ""}`}
          onClick={() => setMode("now")}
        >
          One Year
        </button>
        <button
          type="button"
          className={`nvf-toggle-btn ${
            !isNow ? "nvf-toggle-btn--active" : ""
          }`}
          onClick={() => setMode("future")}
        >
          25 Years
        </button>
      </div>

      {/* Chips / context */}
      <div className="nvf-chip-row">
        <span className="nvf-card-chip nvf-card-chip--accent">
          Same income
        </span>
        <span className="nvf-card-chip">
       
        </span>
      </div>

      {/* Two-path comparison */}
      <div className="nvf-cards">
        <div className="nvf-card">
          <div className="nvf-card-header">
            <span className="nvf-card-title">No Knowledge</span>
          </div>
          <div className="nvf-card-amount">{format(activeData.pathA)}</div>
          <div className="nvf-card-caption">
            {isNow
              ? "Total credit this year"
              : "25 years × $0,000/year"}
          </div>
        </div>

        <div className="nvf-card nvf-card--highlight">
          <div className="nvf-card-header">
            <span className="nvf-card-title">Proper Knowledge</span>
          </div>
          <div className="nvf-card-amount">{format(activeData.pathB)}</div>
          <div className="nvf-card-caption">
            {isNow
              ? "Total credit this year"
              : "25 years × $2,000/year"}
          </div>
        </div>
      </div>

     

      <p className="nvf-footnote">
       
      </p>

   

  

<p>
    <span style={{fontWeight: 'bold', color: '#CC0000', textAlign: "center"}}>
   {/*}     NOT TAX ADVICE. FOR EDUCATIONAL LEARNING ONLY.(*/}
    </span>
</p>

<p className="nvf-footnote">
    Illustrative numbers based on a hypothetical Saver's Credit Case Study, 
    No Credits. vs. maximum credit of up to $2k per year.  Does not account for any compounding growth.
</p>
    </div>
  );
};

export default NowVsFutureComparison;
